import React from "react";
import "./Loader.css";

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="loadspinner" />
        </div>
    );
};

export default Loader;